import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Apostille สูติบัตรไทย — Hague 1961 ยอมรับ 130 ประเทศ","metaTitle":"Apostille สูติบัตร (Birth Certificate) ไทย — ครบใน 5-7 วัน | NYC","metaDesc":"แปล + รับรอง MFA + Apostille สูติบัตรไทย ตามอนุสัญญากรุงเฮก 1961 (ผลบังคับ 15 28 ก.พ. 2570) ใช้ยื่นสัญชาติ วีซ่ — แจ้งเอกสารที่มี รู้ขั้นตอนและระยะเวลาใน 10 นาที"},"en":{"h1":"Apostille Thai Birth Certificate — Hague 1961, 130 countries","metaTitle":"Thai Birth Certificate Apostille — 5-7 Days | NYC","metaDesc":"Translation + MFA + Apostille of Thai birth certificate under the Hague Convention 1961 (in force 15 — Talk to a specialist today; no obligation, fast reply."}} as const;

export const Route = createFileRoute("/en/apostille/birth-certificate")({
  head: () => {
    const url = `${SEO_SITE}/en/apostille/birth-certificate`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/apostille/birth-certificate", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/apostille/birth-certificate", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/apostille/birth-certificate", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/apostille/birth-certificate", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/apostille/birth-certificate", "/en/apostille/birth-certificate")],
    };
  },
  component: () => <SubServicePage slug="apostille/birth-certificate" locale="en" />,
});
